import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

import {
  TextField,
  InputAdornment,
  useMediaQuery,
  MenuItem,
  Box,
} from "@mui/material";
import { s3baseUri } from "../../config/config";
import { get_all_sectors_by_client_type } from "../../DAL/TalentSourceAPI/TalentSourceApi";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { useSnackbar } from "notistack";
import { debounce, show_proper_words } from "../../utils/Constant";
import { useIds } from "../../hook/AdminContext";
import PartnersSkeleton from "../../components/loader/PartnerTypeSkelton";
import {
  clients_listing,
  clients_types_api,
} from "../../DAL/clientTypes/ClientTpes";
import ClientsCard from "./components/ClientsCard";
import ClientHoverImageCard from "./components/ClientHoverImageCard";

export default function ClientsList() {
  const navigate = useNavigate();
  const { setBreadCrumb, findId } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();

  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [clientsWithOutSector, setClientsWithOutSector] = useState([]);
  const [filteredClientsWithOutSector, setFilteredClientsWithOutSector] =
    useState([]);
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState("all");

  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)");
  const { type_slug, source_slug } = useParams();

  const fetchTabs = async () => {
    const response = await get_all_sectors_by_client_type("", 50, 0, type_slug);
    if (response.code === 200) {
      setSectors(response?.data.sectors);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  const fetchCategories = async (id, sectorId, isLoading = false, page = 1) => {
    if (!isLoading) setLoading(true);
    if (isLoading) setIsLoadingMore(true);

    if (!sectorId) {
      sectorId = selectedSector;
    }
    if (selectedSector === "all") {
      sectorId = "";
    }

    try {
      const response = await clients_listing(
        type_slug,
        source_slug,
        searchValue
      );
      if (response.code === 200) {
        if (response?.data?.clients_witout_sector?.length > 0) {
          setClientsWithOutSector(response?.data?.clients_witout_sector);
          setFilteredClientsWithOutSector(
            response?.data?.clients_witout_sector
          );
          setClients([]);
          setFilteredClients([]);
          setSectors([]);
        } else {
          let sectorsArray = response?.data?.client.map((obj) => obj.sector);
          setClients(response?.data?.client);
          setFilteredClients(response?.data?.client);
          setSectors(sectorsArray);
          setClientsWithOutSector([]);
          setFilteredClientsWithOutSector([]);
        }
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
      }
    } catch (error) {}

    setLoading(false);
    setIsLoadingMore(false);
  };
  const loadMoreData = () => {
    if (isLoadingMore || pageNumber >= totalPages) return;
    fetchCategories(findId, selectedSector, true, pageNumber + 1);
  };

  const getTypeTitle = (slug) => {
    const result = show_proper_words(slug);
    return result;
  };

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(source_slug)}`,
        path: `/home`,
        active: false,
      },
      {
        name: getTypeTitle(type_slug),
        path: `/${source_slug}/type/${type_slug}`,
        active: true,
      },
    ]);
  }, [source_slug, type_slug]);

  function handleSearchChange(event) {
    setSearchText(event.target.value);
    debounce(() => {
      setSearchValue(event.target.value);
      setSelectedSector("all");
    }, 1500);

    // if (event.target.value == "") {
    //   setFilteredClientsWithOutSector(clientsWithOutSector);
    //   setFilteredClients(clients);
    //   return;
    // }

    // const query = event.target.value.toLowerCase();

    // if (clientsWithOutSector.length > 0) {
    //   let searchedClient = clientsWithOutSector.filter((item) =>
    //     item.company_name.toLowerCase().includes(query)
    //   );
    //   setFilteredClientsWithOutSector(searchedClient);
    // } else {
    //   let filteredArray = clients;
    //   if (selectedSector !== "all") {
    //     filteredArray = clients.filter((item) =>
    //       item.sector.slug.toLowerCase().includes(selectedSector)
    //     );
    //   }

    //   let searchedClient = filteredArray
    //     .map((item) => ({
    //       ...item,
    //       clients: item.clients.filter((client) =>
    //         client.company_name.toLowerCase().includes(query)
    //       ),
    //     }))
    //     .filter((item) => item.clients.length > 0);

    //   setFilteredClients(searchedClient);
    // }
  }

  function handleSectorChange(event) {
    setSelectedSector(event.target.value);
    if (!event.target.value || event.target.value == "all") {
      setFilteredClients(clients);
    } else {
      let filteredArray = clients.filter((item) =>
        item.sector.slug
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      );
      setFilteredClients(filteredArray);
    }
  }

  // Single useEffect to handle all data fetching
  useEffect(() => {
    // Reset data when type_slug changes
    if (type_slug) {
      setSelectedSector("all");
      setSearchText("");
      setClients([]);
      setFilteredClients([]);
      setClientsWithOutSector([]);
      setFilteredClientsWithOutSector([]);
    }

    // Fetch tabs and clients
    // fetchTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type_slug]);

  const handleNavigateSector = (item) => {
    navigate(`/${source_slug}/type/${type_slug}/${item?.sector.slug}`);
  };

  const handleNavigateDetails = (item) => {
    navigate(`/${source_slug}/type/${type_slug}/detail/${item?._id}`);
  };

  useEffect(() => {
    fetchCategories(findId, selectedSector);
  }, [type_slug, searchValue]);

  return (
    <div className="container-fluid mt-3">
      <div className="row mt-0">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className=" col-md-5 heading-main">
            <h3 className="mb-1">{getTypeTitle(type_slug)}</h3>
            <p>Trusted hospitality businesses we work with</p>
          </div>

          <div className="col-md-7 d-flex justify-content-center justify-content-md-end align-items-center gap-2">
            {sectors?.length > 0 ? (
              <TextField
                select
                className="mui-dropdown"
                label="Select Sector"
                value={selectedSector}
                onChange={handleSectorChange}
                sx={{
                  width: isMobile ? "100%" : 250,
                  marginTop: isMobile ? "16px" : "",
                  minWidth: "282px !important",
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 180,
                        minWidth: isMobile ? "90%" : 250,
                      },
                    },
                  },
                }}
              >
                <MenuItem value="all">All</MenuItem>
                {sectors.map((sector) => (
                  <MenuItem key={sector._id} value={sector?.slug}>
                    <Box
                      sx={{
                        maxWidth: "240px", // text cut hone se pehle ki max width
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={sector.title} // hover pe pura text show hoga
                    >
                      {sector.title}
                    </Box>
                  </MenuItem>
                ))}
              </TextField>
            ) : null}

            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchText}
              className="mui-dropdown search-field"
              onChange={handleSearchChange}
              sx={{
                width: isMobile ? "100%" : 250,
                marginTop: isMobile ? "16px" : "",
                padding: "8px 14px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 21 }} />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>

        {loading ? <PartnersSkeleton /> : ""}
        {filteredClients && filteredClients?.length > 0 ? (
          filteredClients.map((obj, index) => (
            <div className="tw-mb-3">
              <div className="d-flex justify-content-between align-items-end tw-my-3">
                <h4 className="mb-0">{obj?.sector?.title}</h4>
                <button
                  className="btn-outlined-sm"
                  onClick={() => handleNavigateSector(obj)}
                >
                  View All
                </button>
              </div>
              <div className="d-grid gap-3 grid-template">
                {obj.clients.map((item, index) => (
                  <>
                    <ClientHoverImageCard
                      client={item}
                      source_slug={source_slug}
                      type_slug={type_slug}
                      handleNavigateDetails={handleNavigateDetails}
                    />
                  </>
                ))}
              </div>
            </div>
          ))
        ) : filteredClientsWithOutSector.length > 0 ? (
          <>
            <div className="d-grid gap-3 grid-template tw-mt-3">
              {filteredClientsWithOutSector.map((item, index) => (
                <>
                  <ClientHoverImageCard
                    client={item}
                    source_slug={source_slug}
                    type_slug={type_slug}
                    handleNavigateDetails={handleNavigateDetails}
                  />
                </>
              ))}
            </div>
          </>
        ) : (
          <div className="col-12">
            <>
              {filteredClients?.length === 0 && !loading && (
                <RecordNotFound title="No Partners" />
              )}
            </>
          </div>
        )}
      </div>
    </div>
  );
}
